export const ticketQuickReply = {
  name: "Resposta Rápida |||| Respostas Rápidas",
  fields: {
    shortcut: "Atalho",
    title: "Título",
    content: "Conteúdo",
    ticketQueueId: "Fila",
  },
  helpers: {
    shortcut: "Ex: /saudacao, /preco, /horario",
    content: "Use {{contact.name}} para nome do contato, {{agent.name}} para nome do agente",
  },
};
